/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateOrUpdateSecretRequestDto } from '../models/CreateOrUpdateSecretRequestDto';
import type { SecretDto } from '../models/SecretDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SecretService {

    /**
     * @returns void
     * @throws ApiError
     */
    public static deleteSecret({
        name,
    }: {
        name: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/secret',
            query: {
                'name': name,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @returns any Successfully created secret
     * @throws ApiError
     */
    public static createSecret({
        requestBody,
    }: {
        requestBody: CreateOrUpdateSecretRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/secret',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @returns any Successfully updated secret
     * @throws ApiError
     */
    public static update({
        requestBody,
    }: {
        requestBody: CreateOrUpdateSecretRequestDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ui/v1/secret',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * @returns SecretDto Successfully fetch secrets
     * @throws ApiError
     */
    public static getAllSecrets(): CancelablePromise<Array<SecretDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/secrets',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                429: `Too many requests`,
                500: `Internal server error`,
            },
        });
    }

}
